<div class="about-me-form">
  <form
    class="about-me-form_form"
    *ngIf="aboutMeForm"
    [formGroup]="aboutMeForm"
    (submit)="onSubmit()"
    novalidate>
    <a *ngIf="navigationBackButton" class="a-link" (click)="onBack()">
      <img src="../../../../../assets/icons/arrow-back.svg" alt="Buttons" />
      <span class="a-text">{{ 'buttons.labels.back' | translate }} </span>
    </a>
    <h1 class="form-title form-title__bp_lt-md_hidden">
      {{ 'stepper.about' | translate }}
    </h1>
    <app-custom-input-date
      label="captive.form.birthdate"
      placeholder="captive.form.birthdate"
      key="birthdate"
      [control]="birthdateControl"
      [maxDate]="maxDate"
      [minDate]="minDate"
      [submitted]="isSubmited"
      [errorsList]="errorFeedbackList.birthdate"></app-custom-input-date>

    <app-custom-select
      *ngIf="genderOptions"
      label="captive.form.gender"
      placeholder="captive.form.gender"
      key="gender"
      [control]="genderControl"
      [submitted]="isSubmited"
      [errorsList]="errorFeedbackList.gender"
      [options]="genderOptions"
      defaultLabel="select.label.select"></app-custom-select>

    <app-custom-select
      *ngIf="professionOptions"
      label="captive.form.profession"
      placeholder="captive.form.profession"
      key="profession"
      [control]="professionControl"
      [submitted]="isSubmited"
      [errorsList]="errorFeedbackList.profession"
      [options]="professionOptions"
      defaultLabel="select.label.select"
      [isRequired]="true"></app-custom-select>
    <app-button
      type="submit"
      [label]="label"
      [className]="'ind-btn--primary'"
      class="ind-btn-wrapper-100"></app-button>
  </form>
</div>
